import axiosInstance from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const prescriptionSerive = {
    prescriptionPerformance: (companyId, dateRange) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PRESCRIPTION}/${API_PATH.PERFORMANCE}`);
    },

    prescriptionPerformanceByYear: (companyId, year) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PRESCRIPTION}/${API_PATH.PERFORMANCE}/${year}`);
    },

    // profileData: (companyId, npiId) => {
    //     return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PRESCRIPTION}/${npiId}/${API_PATH.PROFILE}`);
    // }, // will be uncommented once optimized

    profileData: (companyId, data) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PRESCRIPTION}/${API_PATH.PROFILES}`,data);
    },

    exportProfileData: (companyId, data) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PRESCRIPTION}/${API_PATH.PROFILES}`,data);
    },
};

export default prescriptionSerive;
